<template>
  <div class="signup">
    <div class="signup-card">
      <div class="card-title">
        <h1>FaibaMkononi Sign Up</h1>
      </div>
      <div class="content">
        <form @submit.prevent="signUp">
          <div class="columns">
            <div class="column is-half">
              <div class="field">
                <label class="label">Username</label>
                <div class="control">
                  <input
                    class="input"
                    :class="{'is-danger':errors.userName}"
                    type="text"
                    v-model="userInfo.userName"
                    placeholder
                    required
                  >
                  <span class="icon is-small is-left">
                    <i class="fas fa-user"></i>
                  </span>
                  <span class="icon is-small is-right">
                    <i class="fas fa-check"></i>
                  </span>
                </div>
                <p
                  class="help"
                  :class="{'is-danger':errors.userName,'is-hidden':!errors.userName}"
                  v-text="errors.userName"
                ></p>
              </div>
            </div>
            <div class="column is-half">
              <div class="field">
                <label class="label">Password</label>
                <div class="control">
                  <input
                    class="input"
                    :class="{'is-danger':errors.password}"
                    type="password"
                    v-model="userInfo.password"
                    required
                  >
                  <span class="icon is-small is-left">
                    <i class="fas fa-user"></i>
                  </span>
                  <span class="icon is-small is-right">
                    <i class="fas fa-check"></i>
                  </span>
                </div>
                <p
                  class="help"
                  :class="{'is-danger':errors.password,'is-hidden':!errors.password}"
                  v-text="errors.password"
                ></p>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-half">
              <div class="field">
                <label class="label">First Name</label>
                <div class="control">
                  <input
                    class="input"
                    :class="{'is-danger':errors.firstName}"
                    type="text"
                    v-model="userInfo.firstName"
                    placeholder
                  >
                  <span class="icon is-small is-left">
                    <i class="fas fa-user"></i>
                  </span>
                  <span class="icon is-small is-right">
                    <i class="fas fa-check"></i>
                  </span>
                </div>
                <p
                  class="help"
                  :class="{'is-danger':errors.firstName,'is-hidden':!errors.firstName}"
                  v-text="errors.firstName"
                ></p>
              </div>
            </div>
            <div class="column is-half">
              <div class="field">
                <label class="label">Second Name</label>
                <div class="control">
                  <input
                    class="input"
                    :class="{'is-danger':errors.secondName}"
                    type="text"
                    placeholder
                    v-model="userInfo.secondName"
                  >
                  <span class="icon is-small is-left">
                    <i class="fas fa-user"></i>
                  </span>
                  <span class="icon is-small is-right">
                    <i class="fas fa-check"></i>
                  </span>
                </div>
                <p
                  class="help"
                  :class="{'is-danger':errors.secondName,'is-hidden':!errors.secondName}"
                  v-text="errors.secondName"
                ></p>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-half">
              <div class="field">
                <label class="label">Phone Number</label>
                <div class="control">
                  <input
                    class="input"
                    :class="{'is-danger':errors.phone}"
                    type="tel"
                    v-model="userInfo.phone"
                    placeholder
                    required
                  >
                  <span class="icon is-small is-left">
                    <i class="fas fa-user"></i>
                  </span>
                  <span class="icon is-small is-right">
                    <i class="fas fa-check"></i>
                  </span>
                </div>
                <p
                  class="help"
                  :class="{'is-danger':errors.phone,'is-hidden':!errors.phone}"
                  v-text="errors.phone"
                ></p>
              </div>
            </div>
            <div class="column is-half">
              <div class="field">
                <label class="label">Email</label>
                <div class="control">
                  <input
                    class="input"
                    :class="{'is-danger':errors.email}"
                    type="email"
                    placeholder
                    v-model="userInfo.email"
                  >
                  <span class="icon is-small is-left">
                    <i class="fas fa-user"></i>
                  </span>
                  <span class="icon is-small is-right">
                    <i class="fas fa-check"></i>
                  </span>
                </div>
                <p
                  class="help"
                  :class="{'is-danger':errors.email,'is-hidden':!errors.email}"
                  v-text="errors.email"
                ></p>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-half">
              <div class="field">
                <label class="label">Location</label>
                <div class="control">
                  <p class="select">
                    <select v-model="userInfo.location">
                      <option
                          v-for="location in locations"
                          :key="location._id"
                          :value="location._id"
                      >{{location.apartment}}</option>
                    </select>
                  </p>
                </div>

              </div>
            </div>

          </div>
          <div class="sub_btn_container">
            <div class="control">
              <button
                id="submit"
                type="submit"
                class="button is-primary"
                :class="{'is-loading':isLoading}"
              >Sign Up</button>
            </div>
          </div>
          <div class="level">
            <div class="level-middle">
              <div class="level-item">
                <!-- <p class="is-success">Dont have an Account yet ?</p> -->
              </div>
            </div>
            <div class="level-right">
              <div class="level-itme">
                <div class="control">
                  <button
                    @click="toLogin"
                    type="button"
                    class="button is-light is-small"
                  >Back to Login</button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import alertify from "alertifyjs";
import {mapActions, mapState} from "vuex";

export default {
  data: function() {
    return {
      userInfo: {
        userName: "",
        firstName: "",
        secondName: "",
        password: "",
        email: "",
        phone: "",
        location:"",
        service: "hotspot"
      },
      errors: {
        userName: "",
        firstName: "",
        secondName: "",
        password: "",
        email: "",
        phone: ""
      },
      isLoading: false
    };
  },
  methods: {
    ...mapActions(["getLocations"]),
    toLogin() {
      this.$router.push("/login");
    },
    signUp() {
      var self = this;
      function validate() {
        var result = true;
        for (const key in self.userInfo) {
          switch (key) {
            case "userName":
              if (/^[A-Za-z0-9_-]{3,16}$/.test(self.userInfo[key])) {
                self.errors[key] = "";
              } else {
                result = false;
                self.errors[key] =
                  "Username length between 3 to 16 characters without spaces or special characters";
              }
              break;
            case "firstName":
              if (self.userInfo[key]) {
                if (/^[a-zA-Z]{3,16}$/.test(self.userInfo[key])) {
                  self.errors[key] = "";
                } else {
                  result = false;
                  self.errors[key] =
                    "Field should not have spaces or special characters";
                }
              }
              break;
            case "secondName":
              if (self.userInfo[key]) {
                if (/^[a-zA-Z]{3,16}$/.test(self.userInfo[key])) {
                  self.errors[key] = "";
                } else {
                  result = false;
                  self.errors[key] =
                    "Field should not have spaces or special characters";
                }
              }
              break;
            case "password":
              break;
            case "email":
              if (self.userInfo[key]) {
                if (
                  /^([a-z0-9_\.\+-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/.test(
                    self.userInfo[key]
                  )
                ) {
                  self.errors[key] = "";
                } else {
                  result = false;
                  self.errors[key] = "Email address not valid";
                }
              }
              break;
            case "phone":
              if (/^([+]254|254|0)(7|1)[0-9]{8}/.test(self.userInfo[key])) {
                self.errors[key] = "";
              } else {
                result = false;
                self.errors[key] = "Phone Number not valid";
              }
              break;
          }
        }
        return result;
      }
      self.isLoading = true;
      if (validate()) {
        axios
          .post(
            "/api/client/signup",
            self.userInfo
          )
          .then(function(response) {
            self.isLoading = false;
            var body = response.data;
            if (body.success) {
              console.log(body.message);
              alertify
                .alert()
                .setting({
                  transition: "zoom",
                  closableByDimmer: false,
                  title: "Account Created",
                  label: "Proceed to login",
                  message:
                    "Account created successfully",
                  onok: function() {
                    self.$router.push("/login");
                  }
                })
                .show();
            } else if (body.validationErrors) {
              body.errors.forEach(error => {
                self.errors[error.path] = error.error;
              });
            }else {
              alertify.warning(body.message)
            }
          })
          .catch(function(error) {
            self.isLoading = false;
            alertify.error("Error creating account");
            console.log(error);
          });
      } else {
        self.isLoading = false;
        console.log("validation fail");
      }
    }
  },
  computed: {
    ...mapState(["locations"])
  },
  created: function () {
    this.getLocations()
  }
};
</script>

<style scoped>
.signup {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.signup-card {
  margin-top: auto;
  margin-bottom: auto;
  background: #fff;
  width: 40em;
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.11);
}

.card-title {
  background-color: #00b89c;
  padding: 1em;
}
.card-title h1 {
  color: #fff;
  text-align: center;
  font-size: 1.2rem;
}
.content {
  padding: 3rem 2.5rem 5rem;
}
input:focus {
  box-shadow: none;
  border-color: #00d1b2;
}

input:focus.is-danger {
  box-shadow: none;
  border-color: #ff3860;
}

.sub_btn_container {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}

#submit {
  width: 100%;
}
</style>
